import script from "./BusinessShareSheet.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessShareSheet.vue?vue&type=script&setup=true&lang=js"

import "./BusinessShareSheet.vue?vue&type=style&index=0&id=70eb3aba&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70eb3aba"]])

export default __exports__